<template>
  <div class="contact">
      <div v-if="!complete">
        <Form v-if="formMounted" :style="{opacity, transform}" @emitComplete="setComplete"/>
      </div>
      <div v-if="complete">
        <component v-bind:is="whichThank"/>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Form from '@/components/Form.vue'
import DesktopThankYou from '@/components/DesktopThankYou.vue'
import MobileThankYou from '@/components/MobileThankYou.vue'
export default {
  name: 'Contact',
  components: {
    Form,
    DesktopThankYou,
    MobileThankYou
  },
  data () {
    return {
      mousedown: false,
      complete: false,
      opacity: 0,
      offset: 900,
      formMounted: false,
      transitionOutFinished: false
    }
  },
  computed: {
    whichThank () {
      return (this.$vuetify.breakpoint.smAndDown) ? 'mobileThankYou' : 'desktopThankYou'
    },
    transform () {
      return 'translateX(' + this.offset + 'px)'
    }
  },
  methods: {
    setComplete (updatedComplete) {
      this.complete = updatedComplete
      console.log(this.complete)
    }
  },
  mounted () {
    if (!this.toggle) {
      this.$store.dispatch('setContactToggle', true)
    }
    this.formMounted = true
    this.$gsap.to(this, { opacity: 1, offset: 0, duration: 1 })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('setContactToggle', false)
    this.$gsap.to(this, { opacity: 0, offset: -900, duration: 1, onComplete: () => { this.transitionOutFinished = true } })
    var interval = setInterval(() => {
      console.log(this.transitionOutFinished)
      if (this.transitionOutFinished) {
        clearInterval(interval)
        next()
      }
    }, 50)
  }
}
</script>

<style lang="scss" scoped>
  *{
    overflow: visible;
  }
  .contact{
    overflow: scroll;
    position: absolute;
    display: grid;
    place-items: center;
    top: 0;
    width: 100vw;
    height: 100vh; /* Fallback for browsers that do not support Custom Properties */
    height: calc(var(--vh, 1vh) * 100);
    padding: 100px 0;
  }
</style>
